module.exports = __webpack_public_path__ + "img/icon_notification_selected.a9b6532c.svg";